import {AxiosError} from 'axios';
import {POST_CREATE_NOTIFICATION_TEMPLATE_URL} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
interface CreateNotificationTemplateRequest {
  templateType: string;
  title: string;
  message: string | null;
}

interface CreateNotificationTemplateResponse {
  uuid: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCreateNotificationTemplate = ({onSuccess, onError}: Input) => {
  const postCreateNotificationTemplate = async (requestData: CreateNotificationTemplateRequest) => {
    const res = await axiosClient.post<CreateNotificationTemplateResponse>(
        POST_CREATE_NOTIFICATION_TEMPLATE_URL,
        requestData
    );
    return res.data;
  };

  return useCustomMutation(postCreateNotificationTemplate, {
    onSuccess,
    onError,
  });
};
